import {
  Box,
  ButtonList,
  Modal,
  ModalBody,
  ModalFoot,
  ModalHead,
  Text,
} from '@dixa/lib-shared-habla';
import { useState } from 'react';

import styles from './detailedErrorMessage.module.scss';
interface DetailedErrorMessageProps {
  readonly message: string;
  readonly description: string | undefined;
}

export const DetailedErrorMessage = ({
  message,
  description,
}: DetailedErrorMessageProps): JSX.Element => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <ButtonList.Item icon="mail" onClick={() => setIsOpen(true)}>
        View detailed error message
      </ButtonList.Item>
      <Modal isOpen={isOpen} onClose={() => setIsOpen(false)}>
        <Box width="800px">
          <ModalHead
            title="Detailed Error Message"
            onClose={() => setIsOpen(false)}
          />
          <ModalBody>
            <Text.Paragraph>{message}</Text.Paragraph>
            {description && (
              <>
                <Box margin="400 0">
                  <Text.Heading variant="heading-3">SMTP Response</Text.Heading>
                  <Text.Paragraph as="pre" className={styles.errorDescription}>
                    {description}
                  </Text.Paragraph>
                </Box>
              </>
            )}
          </ModalBody>
          <ModalFoot
            cancelOnClick={() => setIsOpen(false)}
            cancelName={'Close'}
          />
        </Box>
      </Modal>
    </>
  );
};
